import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { MapGeocoder } from '@angular/google-maps';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { AutoComplete } from 'primeng/autocomplete';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface AddressProps extends FormlyFieldProps, FormlyFieldSelectProps {
  showClear?: boolean;
  delay?: number;
  forceSelection?: boolean;
  autoHighlight?: boolean;
  search: any;
}

@Component({
  selector: 'formly-field-address',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, AutoComplete],
  template: `
    <p-autocomplete
      #element
      [formControl]="formControl"
      [formlyAttributes]="field"
      [suggestions]="addresses()"
      optionLabel="formatted_address"
      [placeholder]="props.placeholder"
      [delay]="props.delay ?? 300"
      [forceSelection]="props.forceSelection ?? false"
      [autoHighlight]="props.autoHighlight ?? false"
      [showClear]="props.showClear ?? false"
      class="w-full"
      lazy="true"
    >
      <ng-template #loadingicon></ng-template>
    </p-autocomplete>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressFieldType extends FieldType<FieldTypeConfig<AddressProps>> {
  @ViewChild('element') element!: AutoComplete;
  private readonly _geocoder = inject(MapGeocoder);

  addresses = signal<any>([]);

  constructor() {
    super();
  }

  ngOnInit() {
    this.props['search'] = this.search.bind(this);
  }

  search(event: string) {
    this._geocoder
      .geocode({
        language: 'it',
        address: event,
      })
      .subscribe({
        next: (res: any) => {
          if (res.results.length > 1) this.addresses.set(res.results);
          else this.formControl.setValue(res.results[0]);
        },
      });
  }
}
